import axios from "axios";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("phr_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export const saveToken = (t) => localStorage.setItem("phr_token", t);
export const clearToken = () => localStorage.removeItem("phr_token");
export const hasToken = () => !!localStorage.getItem("phr_token");
